import { useContext } from "react";
import { langContext, Language } from "../api/Lang";

const el = {
    navLabel: "Αξιολόγηση",
    dlgTitle: "Αξιολόγηση",
    dlgThankYou: "Ευχαριστούμε για την αξιολόγησή σου!",
    pageHeading: "Βοήθησέ μας να γίνουμε καλύτεροι!",
    pageIntro:
        "Διαβάζουμε προσεκτικά κάθε αξιολόγηση που δεχόμαστε και μέσα από αυτές, βελτιώνουμε συνεχώς τις υπηρεσίες που σας παρέχουμε",
    ratingSnacksTitle: "Ποιότητα και Γεύση των μικρογευμάτων μας",
    ratingSnacksSubtitle:
        "Αξιολόγησε μικρογεύματα του κυλικείου όπως πίτες, σάντουιτς, smoothies, μπάρες δημητριακών",
    ratingMealsTitle: "Ποιότητα και Γεύση των γευμάτων του εστιατορίου μας",
    ratingMealsSubtitle:
        "Αξιολόγησε γεύματα του εστιατορίου μας όπως το κυρίως μενού, τις σαλάτες και τα γρήγορα γεύματα",
    ratingDeliveryTitle: "Παράδοση γευμάτων",
    ratingDeliverySubtitle:
        "Σου αρέσει η συσκευασία των γευμάτων; Είναι ικανοποιητική η θερμοκρασία του φαγητού;",
    ratingPlatformTitle: "Ευχρηστία ηλεκτρονικής παραγγελίας",
    ratingPlatformSubtitle:
        "Σου αρέσει η ηλεκτρονική πλατφόρμα; Πραγματοποιείς εύκολα τις παραγγελίες σου ηλεκτρονικά;",
    ratingOverallTitle: "Συνολική Εμπειρία των υπηρεσιών μας",
    ratingOverallSubtitle: "Αξιολόγησε συνολικά την εμπειρία σου με το Lunchbox",
    ratingMoreTitle: "Πες μας περισσότερα :)",
    ratingMoreSubtitle:
        "Έχεις να μας προτείνεις κάτι που θα ήθελες να δεις σε επόμενη έκδοση; Έχεις κάποιο παράπονο από τις υπηρεσίες μας;",
    awfulLabel: "Απογοητευτική",
    greatLabel: "Εξαιρετική",
    commentsPlaceholder: "Γράψε τα σχόλιά σου εδώ",
    send: "Αποστολή",
    submitFailedMsg:
        "Η αξιολόγησή σας δεν στάλθηκε λόγω τεχνικού προβλήματος και δεν αποθηκεύτηκε. Δοκιμάστε ξανά αργότερα ή επικοινωνήστε μαζί μας.",
};

const en: typeof el = {
    navLabel: "Feedback",
    dlgTitle: "Feedback",
    dlgThankYou: "Thank for your feedback!",
    pageHeading: "Help us get better!",
    pageIntro:
        "We read carefully every feedback we receive and through your suggestions, we constantly improve our services",
    ratingSnacksTitle: "Quality and Taste of our snacks",
    ratingSnacksSubtitle:
        "Rate canteen's snacks such as pies, sandwiches, smoothies and cereal bars",
    ratingMealsTitle: "Quality and Taste of our meals",
    ratingMealsSubtitle:
        "Rate restaurant's meals such as main menus, salads and quick meals",
    ratingDeliveryTitle: "Food delivery",
    ratingDeliverySubtitle:
        "Do you like the packaging of the meals? Is the temperature of the food satisfactory?",
    ratingPlatformTitle: "Electronic Ordering Experience",
    ratingPlatformSubtitle:
        "Do you like the online platform? Do you easily place your orders online?",
    ratingOverallTitle: "Overall Experience",
    ratingOverallSubtitle: "Evaluate your overall experience with Lunchbox",
    ratingMoreTitle: "Tell us more :)",
    ratingMoreSubtitle:
        "Do you have any suggestions that you would like to see in the next version? Do you have any complaints from our services?",
    awfulLabel: "Awful",
    greatLabel: "Great",
    commentsPlaceholder: "Write your comments here",
    send: "Send",
    submitFailedMsg:
        "Your feedback could not be sent due to a technical issue and was not saved. Please try again later or contact us.",
};

const feedbackLangs = { el, en };

const missingRatingsMessageByLang: Record<Language, (n: number) => string> = {
    el: (n) => `Παρακαλώ επίλεξε μία βαθμολογία για τις ${n} πρώτες ερωτήσεις`,
    en: (n) => `Please choose a rating for the first ${n} questions`,
};

export function useFeedbackStrings() {
    const [lang] = useContext(langContext);
    return {
        ...feedbackLangs[lang],
        missingRatingsMessage: missingRatingsMessageByLang[lang],
    };
}
